const BLOG_ACTION_TYPES = {
  HANDLE_BLOG: 'HANDLE_BLOG',
  BLOG_SUCCESS: 'BLOG_SUCCESS',
  BLOG_FAILURE: 'BLOG_FAILURE',

  BLOG_RESET: 'BLOG_RESET',
}

export default BLOG_ACTION_TYPES
